/* eslint-disable no-unused-vars */
import { useState } from 'react';
import Ic from '../Icon';

export default function AddTenantModal({ onSave, onClose, existing, properties }) {
  const E = existing || {};
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');
  const [form, setForm] = useState({
    full_name:    E.full_name || E.name || '',
    email:        E.email || '',
    phone:        E.phone || E.ph || '',
    unit:         E.unit || E.u || '',
    property_id:  E.property_id || '',
    monthly_rent: E.monthly_rent || E.rent || '',
    status:       E.status || E.st || 'current',
    lease_start:  '',
    lease_end:    '',
    deposit:      '',
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.full_name) { setError('Tenant name is required.'); return; }
    setSaving(true); setError('');
    const nm = form.full_name.trim();
    const tenantData = {
      full_name:       nm,
      email:           form.email || null,
      phone:           form.phone || null,
      unit:            form.unit || null,
      property_id:     form.property_id || null,
      monthly_rent:    form.monthly_rent ? parseFloat(form.monthly_rent) : null,
      status:          form.status,
      avatar_initials: nm.split(' ').filter(Boolean).map(n=>n[0]).join('').toUpperCase().slice(0,2),
      balance_due:     0,
    };
    const leaseData = (form.lease_start && form.lease_end) ? {
      start_date:       form.lease_start,
      end_date:         form.lease_end,
      monthly_rent:     parseFloat(form.monthly_rent) || 0,
      security_deposit: form.deposit ? parseFloat(form.deposit) : null,
      unit:             form.unit || null,
      property_id:      form.property_id || null,
      status:           'active',
    } : null;
    try {
      await onSave(tenantData, leaseData);
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
      setSaving(false);
    }
  };

  return (
    <div className="mov" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal" style={{maxWidth:560,maxHeight:'90vh',overflowY:'auto'}}>
        <div className="mhd">
          <h2>{existing?'Edit Tenant':'Add Tenant'}</h2>
          <button className="btn btn-gh" style={{padding:'5px 9px'}} onClick={onClose}><Ic n="x" s={15}/></button>
        </div>
        <div className="mbdy">
          {error && <div style={{background:'rgba(248,81,73,.08)',border:'1px solid rgba(248,81,73,.2)',borderRadius:8,padding:'10px 13px',fontSize:13,color:'#f85149',marginBottom:16}}>{error}</div>}
          <div style={{fontSize:11,fontWeight:700,color:'#484f58',letterSpacing:2,textTransform:'uppercase',marginBottom:12}}>Tenant Info</div>
          <div className="fg">
            <div className="fi" style={{gridColumn:'1/-1'}}>
              <label>Full Name *</label>
              <input value={form.full_name} onChange={e=>set('full_name',e.target.value)} placeholder="First and last name"/>
            </div>
            <div className="fi"><label>Email</label><input type="email" value={form.email} onChange={e=>set('email',e.target.value)} placeholder="tenant@email.com"/></div>
            <div className="fi"><label>Phone</label><input value={form.phone} onChange={e=>set('phone',e.target.value)} placeholder="214-555-0000"/></div>
          </div>
          <div style={{fontSize:11,fontWeight:700,color:'#484f58',letterSpacing:2,textTransform:'uppercase',margin:'20px 0 12px'}}>Property & Rent</div>
          <div className="fg">
            <div className="fi">
              <label>Property</label>
              <select value={form.property_id} onChange={e=>set('property_id',e.target.value)}>
                <option value="">Select property</option>
                {(properties||[]).map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </div>
            <div className="fi"><label>Unit</label><input value={form.unit} onChange={e=>set('unit',e.target.value)} placeholder="e.g. A, 101"/></div>
            <div className="fi"><label>Monthly Rent ($)</label><input type="number" value={form.monthly_rent} onChange={e=>set('monthly_rent',e.target.value)} placeholder="0.00"/></div>
            <div className="fi">
              <label>Status</label>
              <select value={form.status} onChange={e=>set('status',e.target.value)}>
                <option value="current">Current</option>
                <option value="late">Late</option>
                <option value="notice">Notice</option>
                <option value="former">Former</option>
              </select>
            </div>
          </div>
          {!existing && <>
            <div style={{fontSize:11,fontWeight:700,color:'#484f58',letterSpacing:2,textTransform:'uppercase',margin:'20px 0 4px'}}>Lease (optional)</div>
            <div style={{fontSize:12,color:'#484f58',marginBottom:12}}>Add lease details now or add them later from the Leases tab.</div>
            <div className="fg">
              <div className="fi"><label>Lease Start</label><input type="date" value={form.lease_start} onChange={e=>set('lease_start',e.target.value)}/></div>
              <div className="fi"><label>Lease End</label><input type="date" value={form.lease_end} onChange={e=>set('lease_end',e.target.value)}/></div>
              <div className="fi"><label>Security Deposit ($)</label><input type="number" value={form.deposit} onChange={e=>set('deposit',e.target.value)} placeholder="0.00"/></div>
            </div>
          </>}
          <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:8}}>
            <button className="btn btn-gh" onClick={onClose}>Cancel</button>
            <button className="btn btn-g" onClick={save} disabled={saving}>
              <Ic n="check" s={14}/>{saving?'Saving...':(existing?'Save Changes':'Add Tenant')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
